module.exports = __webpack_public_path__ + "f87561b8bb354ef83b09a66e54f70e08.png";


//////////////////
// WEBPACK FOOTER
// ./demo/github.png
// module id = 46
// module chunks = 0